function initTrenchSticky() {
  const heroes = document.querySelectorAll(".trench-hero-section");

  if (!heroes.length) return false;

  heroes.forEach(hero => {
    const bar = hero.querySelector(".trench-sticky-bar");
    if (!bar) return;

    hero.style.position = "relative";

    function update() {
      const heroRect = hero.getBoundingClientRect();
      const barHeight = bar.offsetHeight;
      const naturalBarTop = heroRect.bottom - barHeight;
      const heroVisibleHeight = window.innerHeight - heroRect.top;

      if (heroVisibleHeight < barHeight * 1.5) {
        bar.style.position = "absolute";
        bar.style.bottom = "0";
        bar.style.top = "auto";
        bar.style.left = "0";
        bar.style.right = "0";
        bar.style.width = "100%";
      } else if (naturalBarTop <= window.innerHeight - barHeight) {
        bar.style.position = "absolute";
        bar.style.bottom = "0";
        bar.style.top = "auto";
        bar.style.left = "0";
        bar.style.right = "0";
        bar.style.width = "100%";
      } else {
        bar.style.position = "fixed";
        bar.style.bottom = "0";
        bar.style.top = "auto";
        bar.style.left = "0";
        bar.style.right = "0";
        bar.style.width = "100%";
      }
    }

    window.addEventListener("scroll", update, { passive: true });
    update();
  });

  return true;
}

const interval = setInterval(() => {
  const success = initTrenchSticky();
  if (success) clearInterval(interval);
}, 300);

setTimeout(() => clearInterval(interval), 10000);

function initHeaderHide() {
  const header = document.querySelector(".shopify-header-section");
  const drawer = document.querySelector(".header-drawer");
  if (!header) return;

  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    if (drawer && drawer.classList.contains("active")) return;

    const currentScroll = window.scrollY;

    if (currentScroll > lastScroll && currentScroll > 10) {
      header.classList.add("header-hidden");
    } else {
      header.classList.remove("header-hidden");
    }

    lastScroll = currentScroll;
  }, { passive: true });
}

initHeaderHide();


function initAnnouncementHide() {
  const announcement = document.querySelector("#shopify-section-sections--24686061486382__announcement-bar");
  const drawer = document.querySelector(".header-drawer");
  if (!announcement) return;

  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    if (drawer && drawer.classList.contains("active")) return;

    const currentScroll = window.scrollY;

    if (currentScroll > lastScroll && currentScroll > 10) {
      announcement.classList.add("announcement-hidden");
    } else {
      announcement.classList.remove("announcement-hidden");
    }

    lastScroll = currentScroll;
  }, { passive: true });
}

initAnnouncementHide();

const drawerToggle = document.querySelector('.header-drawer-toggle');
const annBar = document.querySelector('#shopify-section-sections--24686061486382__announcement-bar');
const headerSection = document.querySelector('.shopify-header-section');

if (drawerToggle && annBar) {
  drawerToggle.addEventListener('click', function() {
    setTimeout(function() {
      const isOpen = document.querySelector('header-drawer').classList.contains('active');
      annBar.style.display = isOpen ? 'none' : '';
      headerSection.style.top = isOpen ? '0px' : '';
    }, 50);
  });
}


function waitForElement(selector, callback, timeout = 5000) {
  const el = document.querySelector(selector);
  if (el) return callback(el);

  const observer = new MutationObserver(function(mutations, obs) {
    const el = document.querySelector(selector);
    if (el) {
      obs.disconnect();
      callback(el);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), timeout);
}

waitForElement('gp-product-button', function(gpBtn) {
  waitForElement('.globo-swatch-list', function(variantSelector) {

    gpBtn.addEventListener('click', function(e) {
      const rect = variantSelector.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;

      if (!isVisible) {
        e.preventDefault();
        e.stopImmediatePropagation();
        variantSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });

      }
    }, true);

  });
});

waitForElement('.title-main', function(mainTitle) {
  waitForElement('.title-sticky', function(stickyTitle) {

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        stickyTitle.style.display = entry.isIntersecting ? 'none' : 'block';
      });
    });

    observer.observe(mainTitle);

  });
});

waitForElement('gp-product-button', function(gpBtn) {
  waitForElement('.globo-swatch-list', function(variantSelector) {
    const btnText = gpBtn.querySelector('.button-text');

    const textObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        btnText.textContent = entry.isIntersecting ? 'Add to cart' : 'Select size';
      });
    });

    textObserver.observe(variantSelector);

  });
});

document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.querySelector('[id*="gp-carousel"]');
  if (!carousel) return;

  const slideCount = carousel.querySelectorAll('[class*="gem-slider-item"]').length / 1;

  // Create dot container
  const dotContainer = document.createElement('div');
  dotContainer.id = 'custom-gallery-dots';

  // Append to image wrapper so position: absolute works correctly
  const imageWrapper = carousel.querySelector('[class*="gp-featured-image-wrapper"]');
  if (imageWrapper) {
    imageWrapper.style.position = 'relative';
    imageWrapper.appendChild(dotContainer);
  } else {
    carousel.appendChild(dotContainer); // fallback
  }

  // Create dots
  const dots = [];
  for (let i = 0; i < slideCount; i++) {
    const dot = document.createElement('span');
    if (i === 0) dot.classList.add('active');
    dotContainer.appendChild(dot);
    dots.push(dot);
  }

  // Watch active-index attribute
  const observer = new MutationObserver(() => {
    const activeEl = carousel.querySelector('[active-index]');
    const activeIndex = parseInt(
      activeEl?.getAttribute('active-index') ??
      carousel.getAttribute('active-index') ??
      0
    );
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === activeIndex);
    });
  });

  observer.observe(carousel, {
    subtree: true,
    attributes: true,
    attributeFilter: ['active-index']
  });
});

/**
 * Waits for Measmerize's script to finish loading (window.measmerize.button.mount
 * becoming available), mounts the button if it hasn't rendered yet, then clicks
 * the real element Measmerize rendered inside #measmerize-button.
 *
 * onFail is called if Measmerize never becomes available within the timeout,
 * OR if it becomes available but never renders any clickable content inside
 * #measmerize-button (which happens if Measmerize itself rejects the mount,
 * e.g. a "retailer not found" or "garmentType info doesn't exist" error —
 * that's a Measmerize account/data problem, not something a retry can fix).
 */
function openMeasmerize(onFail) {
  let attempts = 0;
  const maxAttempts = 30; // ~6 seconds at 200ms
  const pollInterval = setInterval(function () {
    attempts++;
    const button = document.querySelector('#measmerize-button');
    const mountFn = window.measmerize && window.measmerize.button && window.measmerize.button.mount;

    if (button && mountFn) {
      clearInterval(pollInterval);

      if (!button.children.length) {
        window.measmerize.button.mount();
      }

      // Give it a brief moment to render its content, then click the real inner element
      setTimeout(function () {
        const inner = button.querySelector('button, a') || button.firstElementChild;
        if (inner) {
          inner.click();
        } else if (typeof onFail === 'function') {
          onFail();
        }
      }, 150);
    } else if (attempts >= maxAttempts) {
      clearInterval(pollInterval);
      if (typeof onFail === 'function') onFail();
    }
  }, 200);
}

function addFindYourSize() {
  const sizeList = document.querySelector('ul.value');

  if (sizeList) {
    if (sizeList.querySelector('.find-your-size-btn')) return;

    const li = document.createElement('li');
    li.className = sizeList.querySelector('li').className;
    li.classList.add('find-your-size-btn');
    li.style.cssText = `
      cursor: pointer;
      font-size: 11px;
      flex: 1 !important;
      text-align: center;
      border: 0px solid #CFCFCF !important;
      background: white !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    `;
    li.innerHTML = `<span style="font-size: 10px; line-height: 1.2; cursor: pointer; color: #000;">Find Your Size</span>`;

    li.addEventListener('click', function () {
      openMeasmerize(function () {
        console.warn('Measmerize never became available — "Find Your Size" click did nothing. (Note: if window.measmerize logs a "retailer not found" or "garmentType info doesn\'t exist" warning/error in the console, this is a Measmerize account/data issue, not a script timing issue, and retrying will not help until that\'s fixed on their end.)');
        // Optional: surface this to the shopper instead of failing silently
        // li.querySelector('span').textContent = 'Size guide unavailable';
      });
    });

    sizeList.appendChild(li);
  }
}

document.addEventListener('DOMContentLoaded', addFindYourSize);
setTimeout(addFindYourSize, 1000);

function expandProductGroups() {
  document.querySelectorAll('.gsw-list-products-group').forEach(function(group) {
    const legend = group.closest('.gsw-item-product-group')?.querySelector('legend');
    const labelText = legend?.firstChild?.textContent?.trim().toLowerCase();

    if (labelText === 'quantity' || labelText === 'style') {
      group.style.cssText = 'width: 100% !important; display: flex !important;';
      group.querySelectorAll('.gsw-prg-item').forEach(function(item) {
        item.style.cssText = 'flex: 1 !important; text-align: center !important;';
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', expandProductGroups);
setTimeout(expandProductGroups, 1000);
setTimeout(expandProductGroups, 2000);

const observer = new MutationObserver(expandProductGroups);
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.boxer-trunks-block');
  if (section) {
    section.style.cursor = 'pointer';
    section.addEventListener('click', function () {
      window.location.href = 'pages/boxer-trunks';
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const section = document.querySelector('.boxer-briefs-block');
  if (section) {
    section.style.cursor = 'pointer';
    section.addEventListener('click', function () {
      window.location.href = 'pages/boxer-briefs';
    });
  }
});